var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLayers = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 12L14.52 7.7025L15.75 6.75L9 1.5L2.25 6.75L3.4725 7.7025L9 12ZM8.9925 13.905L3.465 9.6075L2.25 10.5525L9 15.8025L15.75 10.5525L14.5275 9.6L8.9925 13.905ZM13.3048 6.75094L8.99982 3.39844L4.69482 6.75094L8.99982 10.1034L13.3048 6.75094Z",
    fill: "#ffffff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLayers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/layers.1d9f29778d859ed998d3fc85cbc09ed7.svg";